import type { ReactElement } from 'react';
import { formatDate } from '@xdocs/i18n';
import { useI18n, cn } from '@xdocs/ui';
import type { AdminUserDetail } from '@xdocs/schemas';
import { useAdminT } from '../../../../features/admin/index.js';
import styles from './SubscriptionTab.module.css';

export interface SubscriptionTabProps {
  detail: AdminUserDetail;
}

/** F20/F24 subscription read view — reconciliation flags and Paddle-side
 * invoice detail live on the admin Billing page (F70, another builder's
 * `routes/admin/billing`); this only surfaces what `AdminUserDetail`
 * already carries for THIS user. */
export function SubscriptionTab({ detail }: SubscriptionTabProps): ReactElement {
  const { locale } = useI18n();
  const { t } = useAdminT();
  const { subscription } = detail;

  if (!subscription) {
    return (
      <div className={cn(styles['panel'])}>
        <p>{t('admin:userDetail.subscription.none')}</p>
      </div>
    );
  }

  return (
    <div className={cn(styles['panel'])}>
      <div className={cn(styles['tier'])}>
        {t(`admin:tier.${subscription.tier}`)} · {/* i18n-exempt: brand name, never translated */}Paddle
      </div>
      <p>{t('admin:userDetail.subscription.status', { status: subscription.status })}</p>
      {subscription.currentPeriodEnd && <p>{t('admin:userDetail.subscription.renews', { date: formatDate(locale, subscription.currentPeriodEnd, { dateStyle: 'medium' }) })}</p>}
      {subscription.cancelAt && <p>{t('admin:userDetail.subscription.cancelAt', { date: formatDate(locale, subscription.cancelAt, { dateStyle: 'medium' }) })}</p>}
    </div>
  );
}
